<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Clientes</h1>
          <p class="view-header__subtitle">Administrá los clientes de la sucursal.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn" @click="exportarCSV()">
            <i class="bi bi-download"></i>
            Exportar CSV
          </button>
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="newClient">
            <i class="bi bi-person-plus"></i>
            Nuevo cliente
          </button>
        </div>
      </div>
    </div>
    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar cliente...">
          </div>
          <div class="filters-panel__field">
            <q-select v-model="statusFilter" :options="statusFilterOptions" />
          </div>
        </div>
      </div>
    </div>
    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @viewHistory="viewHistoryMethod"
        @swithActive="swithActive"
        @viewCC="viewCCMethod"
        @edit="changeClientId"
        @delete="deleteClient"
      />
    </div>
    <NuevoCliente
      v-if="showModal"
      :clientId="clientIdParent"
      @edit="changeClientId"
      @confirmsave="refreshTable()"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import QSelect from '@/components/shared/QSelect.vue';
import NuevoCliente from "./Nuevo-cliente.vue";
import exportsMixin from "../../../mixins/exportsMixin";

export default {
  components: {
    VdtnetTable,
    QSelect,
    NuevoCliente,
  },
  mixins: [exportsMixin],

  data: function () {
    return {
      showModal: false,
      doSearch: "",
      showNewClient: true,
      clientIdParent: null,
      statusFilter: 'active',
      statusFilterOptions: [
        { value: 'active', label: 'Clientes activos' },
        { value: 'inactive', label: 'Clientes inactivos' },
        { value: 'all', label: 'Todos los clientes' },
      ],
      isLoading: false,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/clients/list",
          data: (d) => {
            d.status = this.statusFilter;
            return d;
          },
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: 100,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false,
      },
      fields: {
        name: {
          label: "Nombre",
          defaultOrder: 'asc',
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        cuit: { label: "CUIT", width: "130px" },
        phone_1: { label: "Teléfono", width: "130px" },
        phone_2: { label: "Celular", width: "130px" },
        estado: {
          isLocal: true,
          label: "Estado",
          width: "100px",
          align: "center",
          render: (data, type, client) => {
            if (type !== 'display') return '';
            if (client.name === "CONSUMIDOR FINAL") return '';
            const isActive = client.active === 1;
            const variant = isActive ? 'success' : 'danger';
            const label = isActive ? 'Activo' : 'Inactivo';
            const title = isActive ? 'Click para desactivar' : 'Click para activar';
            return `<span data-action="swithActive" class="status-badge status-badge--${variant}" title="${title}" style="cursor:pointer">${label}</span>`;
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "150px",
          align: "right",
          render: (_data, _type, client) => {
            if (client.name === "CONSUMIDOR FINAL") return '';
            return `
              <div class="table-action-group">
                <button data-action="viewHistory" class="table-action-btn" type="button" title="Ver historial">
                  <i class="bi bi-clock-history"></i>
                </button>
                <button data-action="viewCC" class="table-action-btn" type="button" title="Ver cuenta corriente">CC</button>
                <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button data-action="delete" class="table-action-btn" type="button" title="Eliminar">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            `;
          },
        },
      },

    }
  },
  mounted() {
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  methods: {  
    refreshTable() {
      var vm = this;
      if (vm.$refs.table !== undefined) vm.$refs.table.reload();
    }, 
    viewHistoryMethod(data) {
      this.$router.push({name: 'Historial de ventas del cliente', params: { clientId: data.id }})
    },
    viewCCMethod(data) {
      this.$router.push({name: 'Detalle de cuenta corriente de cliente', params: { clientId: data.id }})
    },
    changeClientId(data) {
      this.clientIdParent = data.id;
      this.showModal= true;
    },
    newClient(){
      this.clientIdParent = null;
      this.showModal = true;
    },
    swithActive(data){
      let vm = this;
      let outdata={'id' : data.id,};
      if(confirm("¿Está seguro que cambiar el estado de este cliente?") == true){
        this.$http.post("/api/clients/switchactive", outdata)
        .then(response => {
          if(response.data.success){
            vm.refreshTable();
          }
        })
        .catch(error => {
          alert(error);
        })
      }
    },
    deleteClient(data) {
      if (confirm("¿Está seguro que desea borrar este cliente?") == true) {
        this.$http
          .post("/api/clients/delete", { id: data.id })
          .then((response) => {
            
            if (response.data.code == 201) {
              this.refreshTable();
            }
          });
      }
    },
    exportarCSV(){
      this.$http.post(process.env.VUE_APP_BASE_URL+"/api/clients/exportClientListCSV")
        .then(() => {
      });
    },
  },

  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
    statusFilter() {
      this.refreshTable();
    },
  },

  computed: {
    
  }  
};
</script>

